<template>
  <div>
    <b-container
      class="main-container p-t-78 p-b-100"
    >
      <header class="text-center text-primary main-grey f-w-600 m-b-50">
        <h1 class="f-s-48 l-h-62 l-s-175 m-b-24">
          Get in touch with us
        </h1>
        <p class="f-s-14 l-h-32 l-s-145 m-b-24">
          For any inquiries please fill out the form below and we will make sure
          to get back to you as soon as possible.
        </p>
        <p class="f-s-14 l-h-32 l-s-145">
          You can also e-mail us at info@statecs.am
        </p>
      </header>
      <ValidationObserver
        ref="contactUsRef"
        vid="contactUs"
        tag="div"
      >
        <b-form v-if="showForm">
          <b-row>
            <b-col
              md="6"
              sm="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="First Name"
                vid="name"
                class="m-b-40"
                tag="div"
              >
                <label
                  :for="`firstName`"
                  class="required"
                >
                  First Name
                </label>
                <b-form-input
                  id="firstName"
                  v-model="form.first_name"
                  class="form-input bg-white-1"
                  type="text"
                  :class="{'is-invalid': errors[0]}"
                  lazy
                />
                <b-form-invalid-feedback v-if="errors[0]">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Last Name"
                class="m-b-40"
                tag="div"
              >
                <label
                  :for="`lastName`"
                  class="required"
                >
                  Last Name
                </label>
                <b-form-input
                  id="lastName"
                  v-model="form.last_name"
                  class="form-input bg-white-1"
                  type="text"
                  :class="{'is-invalid': errors[0]}"
                  lazy
                />
                <b-form-invalid-feedback v-if="errors[0]">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{
                  required: true,
                  email: true,
                }"
                name="Email"
                class="m-b-40"
                tag="div"
              >
                <label
                  :for="`email`"
                  class="required"
                >
                  Email
                </label>
                <b-form-input
                  id="email"
                  v-model="form.email"
                  class="form-input bg-white-1"
                  :class="{'is-invalid': errors[0]}"
                  lazy
                />
                <b-form-invalid-feedback v-if="errors[0]">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Company Name"
                class="m-b-40"
                tag="div"
              >
                <label
                  :for="`companyName`"
                  class="required"
                >
                  Company Name
                </label>
                <b-form-input
                  id="companyName"
                  v-model="form.company_name"
                  class="form-input bg-white-1"
                  type="text"
                  :class="{'is-invalid': errors[0]}"
                  lazy
                />
                <b-form-invalid-feedback v-if="errors[0]">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-col>
            <b-col
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Message"
                class="m-b-40"
                tag="div"
              >
                <label :for="`coverLetter`">
                  Message
                </label>
                <b-form-textarea
                  id="coverLetter"
                  v-model="form.message"
                  rows="4"
                  class="bg-white-1"
                  :class="{'is-invalid': errors[0]}"
                  no-resize
                  lazy
                />
                <b-form-invalid-feedback v-if="errors[0]">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-col>
          </b-row>
          <div class="text-center">
            <b-btn
              variant="primary"
              class="btn-main-bg-blue btn-main-bg-blue-bordered"
              :disabled="disabled"
              @click.stop.prevent="handleSubmit"
            >
              Submit
            </b-btn>
          </div>
        </b-form>
      </ValidationObserver>
    </b-container>
    <CoverBg
      bg="cover-bg-page-bottom"
    />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex';
import CoverBg from '@/components/CoverBg';
import { showNotification } from '@/helpers/helpers';

const defaultForm = {
  first_name: '',
  last_name: '',
  email: '',
  company_name: '',
  message: '',
};

export default {
  name: 'ContactUs',
  components: {
    CoverBg,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      disabled: false,
      showForm: true,
      form: {
        ...defaultForm,
      },
    };
  },
  methods: {
    ...mapActions([
      'submitContactUsForm',
    ]),
    handleSubmit() {
      this.$refs.contactUsRef.validate()
        .then(async (success) => {
          if (!success) {
            showNotification({
              ctx: this,
              variant: 'danger',
              title: 'Form Validation',
              message: 'Please check all mandatory fields',
            });
            return;
          }
          this.disabled = true;
          await this.submitContactUsForm({
            body: this.form,
            notificationParams: {
              ctx: this,
              variant: 'success',
              title: 'Success',
              message: 'Form submitted successfully',
            },
          })
            .then(() => {
              this.disabled = false;
              this.resetForm();
            })
            .catch(() => {
              this.disabled = false;
            });
        });
    },
    resetForm() {
      this.form = {
        ...defaultForm,
      };
      this.showForm = false;
      this.$nextTick(() => {
        this.showForm = true;
      });
    },
  },
};
</script>
